import { useDualMode } from "@mirage/service-experimentation/useDualMode";
import { typeahead } from "@mirage/service-typeahead-search/service/types";
import { isInsideExtensionSidePanel } from "@mirage/shared/util/webExtensionsHelpers";
import i18n from "@mirage/translations";
import { useAtomValue } from "jotai";
import { useEffect, useState } from "react";
import { ModeAtom } from "../atoms/mode";

/**
 * This hook is used to manage the omnibox input mode
 */

export const useOmniboxInputMode = ({
  isSlimMode = false,
}: {
  isSlimMode?: boolean;
}) => {
  const omniboxScopedMode = useAtomValue(ModeAtom);
  const { isDualModeLauncher } = useDualMode();

  const [hasBackButton, setHasBackButton] = useState(false);

  const OMNIBOX_SCOPED_MODE_TO_PLACEHOLDER_MAP = {
    [typeahead.Mode.Default]: isDualModeLauncher
      ? i18n.t("omnibox_mode_find_anything_with_dash")
      : i18n.t("omnibox_mode_find_anything"),
    [typeahead.Mode.Find]: i18n.t("omnibox_mode_find"),
    [typeahead.Mode.Ask]: i18n.t("omnibox_mode_ask"),
    [typeahead.Mode.Write]: i18n.t("omnibox_mode_write"),
    [typeahead.Mode.Organize]: i18n.t("omnibox_mode_organize"),
  };

  const omniboxPlaceholder =
    OMNIBOX_SCOPED_MODE_TO_PLACEHOLDER_MAP[omniboxScopedMode];

  useEffect(() => {
    setHasBackButton(
      omniboxScopedMode !== typeahead.Mode.Default &&
        (!isSlimMode || isInsideExtensionSidePanel()),
    );

    return () => {
      setHasBackButton(false);
    };
  }, [omniboxScopedMode, isSlimMode]);

  return {
    omniboxPlaceholder,
    hasBackButton,
  };
};
